import { useEffect, useState} from "react";
import {BaseControl, BaseControlProps} from "../BaseControl";
import {RootState, useAppDispatch, useAppSelector} from "../../../store";
import Select, {Props} from "react-select";
import { fetchApplicationStatuses } from "../../../store/slices/guides";

const colourStyles = {
    control: (styles: any) => ({ ...styles, maxWidth: "100%", borderColor: "#E2E8F0" }),
};

export interface VacancyApplicationStatusOption {
    value: string;
    label: string;
}


interface VacancyApplicationStatusSelectProps
    extends BaseControlProps,
        Omit<Props<any, false>, "options"> {
    selectedValue?: string;
    vacancyId: number;
}

export const VacancyApplicationStatusSelect = (props: VacancyApplicationStatusSelectProps) => {
    const { applicationStatuses } = useAppSelector(
        (state: RootState) => state.guides
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchApplicationStatuses(props.vacancyId))
    }, [props.vacancyId, dispatch])

    const [VacancyApplicationStatusList, setVacancyApplicationStatusList] = useState<any[]>([])

    useEffect(() => {
        setVacancyApplicationStatusList(applicationStatuses.map(status => ({
            value: status.id.toString(),
            label: status.name,
            is_sheduled: status.is_scheduled,
            reasons: status.reasons
        })))
    }, [applicationStatuses])



    const selectedOption = VacancyApplicationStatusList.find(option => option.value === props.selectedValue);


    return (
        <BaseControl {...props} fieldTitle ={"Этап"}>
            <Select
            menuPosition="fixed"
                className="basic-single"
                classNamePrefix="select"
                isSearchable={true}
                name="color"
                options={VacancyApplicationStatusList}
                styles={colourStyles}
                placeholder="Выберите этап"
                value={selectedOption}
                onChange={props.onChange}
            />
        </BaseControl>
    );
};
